import * as Yup from 'yup'
import { useFormik } from "formik"
import { Button } from "@mui/material"
import Ajax from '../../../Ajax'
import { store } from '../../../stores/Store'
import Field from '../fields/Field'
import React from 'react'
import { Icons } from '../../../misc/Icons'


const hasComplexValidationError = (username: string, password: string) => {

    if (password.toLowerCase().includes("password")) {
        return "You password must not contain the word 'password'"
    }

    for (var i = 0; i < password.length - 4; i += 1) {
        var passwordSubstring = password.slice(i, i+4)
        if (username.toLowerCase().includes(passwordSubstring.toLowerCase())) {
            return `You are not allowed to have a password which has any part (4 characters or more) of the username '${username}'`
        }
    }

    return false
}


export default function PasswordSetForm () {

    const [revealPasswordText, setRevealPasswordText] = React.useState(false)

    var formik = useFormik({

        initialValues: {
            password: "",
        },

        validationSchema: Yup.object({
            password: Yup.string().required("This field is required").matches(
                /(?!.*[`'"\\])(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{12,}/,
                "Your new password must contain at least 12 characters with 1 lowercase letter, 1 uppercase and one number. Banned characters are \\ ' \" and `")
        }),

        onSubmit: async (values) => {

            var complexValidationError = hasComplexValidationError(store.AppStore.sessionInfo.username, values.password)
            if (complexValidationError) {
                formik.setFieldError("password", complexValidationError)
                return
            }

            var userPayload = {
                uid: store.AppStore.sessionInfo.userUid,
                password: values.password,
                canUpdate: true,
                canEdit: true,
            }

            await Ajax.Node.Edit("user", userPayload).then(() => {
                store.AppStore.navigate("/app/main")
            }).catch((response) => {
                var message = response.data?.detail ? response.data?.detail : "An error occured"
                formik.setErrors({password: message})
            })
        }
    })

    return (
        <form autoComplete="off" className="form" onSubmit={formik.handleSubmit} style={{minWidth: "360px"}}>
            <h2>Update Your Password</h2>

            <div className="form-fields">
                <div>
                    <p>Your new password must contain at least 12 characters with 1 lowercase letter, 1 uppercase and one number.</p>
                    <p>Banned characters are \ ' " and `</p>
                </div>

                <Field.Text
                    formik
                    label="Password"
                    name="password"
                    type={revealPasswordText ? "text" : "password"}
                    autoComplete={false}
                    value={formik.values.password}
                    warning={formik.submitCount && formik.errors.password ? formik.errors.password : false}
                    onChange={(e) => {
                        formik.setFieldValue("password", e.target.value)
                    }} />
            </div>

            <div className="form-buttons">
                <Button className="btn btn-sm" onClick={() => setRevealPasswordText(!revealPasswordText)}>
                    {revealPasswordText ? "Hide password" : "Reveal password"}
                </Button>

                <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    className="btn btn-sm"
                    disabled={formik.isSubmitting}>
                    Submit
                </Button>
            </div>
        </form>
    )
}